import { useState, useEffect, useRef } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import axios from "axios";
import Battle from "../battle/Battle";
import Question from "../question/Question";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useLocalStorage } from "@uidotdev/usehooks";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Grid,
  DialogContentText,
} from "@mui/material";
import { ArrowBackIosNewRounded } from "@mui/icons-material";
import TextEditor from "../Components/TextEditor/TextEditor";
import CustomSwitch from "../Components/CustomSwitch/CustomSwitch";
import { hasStoredTabAccess } from '../utils/access';

const AUDIO_LANGUAGE_OPTIONS = ["English", "Hindi"];

const Mission = () => {
  const { skillId, stageId } = useParams();
  const [missions, setMissions] = useState([]);
  const [isAddDialogOpen, setAddDialogOpen] = useState(false);
  const [isReplicateDialogOpen, setReplicateDialogOpen] = useState(false);
  const [currentMissionId, setCurrentMissionId] = useState(null);
  const [replicateFormData, setReplicateFormData] = useState({
    newSkillId: "",
    newStageId: "",
    newMissionName: "",
  });
  const [formData, setFormData] = useState({ missionId: "", name: "" });
  const isAuthorized = hasStoredTabAccess('Skills');
  const [insertedQuestionIds, setInsertedQuestionIds] = useState([]);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const [missionToDelete, setMissionToDelete] = useState(null);
  const [skills, setSkills] = useState([]);
  const [stages, setStages] = useState([]);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [selectedAudioFiles, setSelectedAudioFiles] = useState([]);
  const [selectedAudioLanguages, setSelectedAudioLanguages] = useState([]);
  const [selectedAudioUploadScope, setSelectedAudioUploadScope] =
    useState("all");
  const [replaceAudioLanguages, setReplaceAudioLanguages] = useState({});
  const [audioScopes, setAudioScopes] = useState({});
  const [audioAction, setAudioAction] = useState(null);
  const [pendingAudioConfirmation, setPendingAudioConfirmation] = useState(null);
  const autoOpenedMissionId = useRef(null);

  // eslint-disable-next-line no-unused-vars
  const [token, setToken] = useLocalStorage("token", null);
  const [visibility, setVisibility] = useState(formData.visibility === "1");

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const editMissionId = searchParams.get("editMissionId");
  const returnTo = searchParams.get("returnTo");
  const handleBack = () => {
    navigate(
      returnTo?.startsWith("/") ? returnTo : `/skills/${skillId}/stage`
    );
  };

  const handleVisibilityChange = (event) => {
    setVisibility(event.target.checked);
    setFormData((prevData) => ({
      ...prevData,
      visibility: event.target.checked ? "1" : "0",
    }));
  };
  console.log(formData,"Formdata");

  const handleUploadChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      shouldUpload: event.target.checked ? 1 : 0,
    }));
  };

  const handleStartInstructionChange = (event) => {
    setFormData((prevData) => ({
      ...prevData,
      isStartRequired: event.target.checked ? 1 : 0
    }));
  };

  const fetchSkills = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/skills/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setSkills(response.data.data || []);
    } catch (error) {
      console.error("Error fetching skills:", error);
      setSkills([]);
    }
  };

  const fetchStages = async (skillId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/stages/all/${skillId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedStages = response.data.data.stages;
      console.log("Fetched Stages:", fetchedStages);
      setStages(Array.isArray(fetchedStages) ? fetchedStages : []);
    } catch (error) {
      console.error("Error fetching stages:", error);
      setStages([]);
    }
  };

  useEffect(() => {
    fetchSkills();
  }, []);

  useEffect(() => {
    if (selectedSkill) {
      console.log("Selected Skill ID:", selectedSkill.skill_id);
      fetchStages(selectedSkill.skill_id);
    }
  }, [selectedSkill]);

  const inputFields = [
    { label: "Mission ID", name: "missionId", type: "number", disabled: true },
    { label: "Mission Name", name: "name" },
    { label: "Video Link", name: "videoLink" },
    { label: "Mission Order", name: "missionOrder", type: "number" },
    // { label: "Question Type", name: "questionType" },
    { label: "Instructions", name: "instructions", type: "multiline" },
    { label: "Display Columns", name: "displayColumns", type: "number" },
    { label: "Speed", name: "speed", type: "time" },
    { label: "Accuracy %", name: "accuracy", type: "number" },
    { label: "Max Questions", name: "maxQuestions", type: "number" },
    // { label: "Visibility", name: "visibility", type: "number" },
    { label: "Coin Type", name: "coinType", type: "number" },
  ];

  const fetchData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/missions/all/${stageId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.data) {
        setMissions(response.data.data);
        return response.data.data;
      } else {
        console.error("Empty mission data received");
        return [];
      }
    } catch (error) {
      console.error("Error fetching mission data:", error);
      return [];
    }
  };

  useEffect(() => {
    fetchData();
  }, [token]);

  const handleAdd = () => {
    setFormData({ missionId: "", name: "" });
    setSelectedAudioFiles([]);
    setSelectedAudioLanguages([]);
    setSelectedAudioUploadScope("all");
    setReplaceAudioLanguages({});
    setAudioScopes({});
    setPendingAudioConfirmation(null);
    setVisibility(false);
    setAddDialogOpen(true);
  };

  const openMissionEditDialog = (missionToEdit) => {
    if (!missionToEdit) {
      toast.error("Mission not found for editing.");
      return;
    }

    const audioFiles = getMissionAudioFiles(missionToEdit);

    setFormData({
      missionId: missionToEdit.mission_id,
      name: missionToEdit.mission_name,
      videoLink: missionToEdit.video_link,
      startInstructions: missionToEdit.start_instructions,
      missionOrder: missionToEdit.mission_order,
      questionType: missionToEdit.question_type || "lorem",
      instructions: missionToEdit.instructions,
      displayColumns: missionToEdit.display_columns,
      speed: missionToEdit.speed,
      accuracy: missionToEdit.accuracy,
      maxQuestions: missionToEdit.max_questions,
      shouldUpload: missionToEdit.upload_required,
      visibility: missionToEdit.visibility,
      coinType: missionToEdit.coin_type,
      specializationId: missionToEdit.specialization_id,
      isStartRequired: missionToEdit.is_start_required,
      audioUrl: missionToEdit.audio_url,
      audioKey: missionToEdit.audio_key,
      audioFiles,
    });
    setSelectedAudioFiles([]);
    setSelectedAudioLanguages([]);
    setSelectedAudioUploadScope("all");
    setReplaceAudioLanguages({});
    setAudioScopes({});
    setPendingAudioConfirmation(null);
    setVisibility(
      missionToEdit.visibility === "1" ||
        missionToEdit.visibility === 1 ||
        missionToEdit.visibility === true
    );

    setAddDialogOpen(true);
  };

  const handleEdit = (missionId) => {
    const missionToEdit = missions.find(
      (mission) => String(mission.mission_id) === String(missionId)
    );

    openMissionEditDialog(missionToEdit);
  };

  useEffect(() => {
    if (
      !editMissionId ||
      !missions.length ||
      autoOpenedMissionId.current === editMissionId
    ) {
      return;
    }

    const missionToEdit = missions.find(
      (mission) => String(mission.mission_id) === String(editMissionId)
    );

    if (!missionToEdit) {
      return;
    }

    autoOpenedMissionId.current = editMissionId;
    openMissionEditDialog(missionToEdit);
  }, [editMissionId, missions]);

  const handleReplicate = (missionId) => {
    setCurrentMissionId(missionId);
    setReplicateDialogOpen(true);
    setReplicateFormData({
      newSkillId: "",
      newStageId: "",
      newMissionName: "",
    });
    setSelectedSkill(null);
    setStages([]);
  };

  const handleReplicateDialogClose = () => {
    setReplicateDialogOpen(false);
    setCurrentMissionId("");
    setReplicateFormData({
      newSkillId: "",
      newStageId: "",
      newMissionName: "",
    });
    setSelectedSkill(null);
    setStages([]);
  };

  const handleSkillSelectChange = (event) => {
    const selectedSkillId = event.target.value;
    const selectedSkillObj = skills.find(
      (skill) => skill.skill_id === selectedSkillId
    );
    setSelectedSkill(selectedSkillObj);
    setReplicateFormData((prevData) => ({
      ...prevData,
      newSkillId: selectedSkillId,
      newStageId: "",
    }));
    fetchStages(selectedSkillId);
  };

  const handleStageSelectChange = (event) => {
    const selectedStageId = event.target.value;
    setReplicateFormData((prevData) => ({
      ...prevData,
      newStageId: selectedStageId,
    }));
  };

  const handleReplicateSubmit = async () => {
    try {
      if (
        !replicateFormData.newSkillId ||
        !replicateFormData.newStageId ||
        !replicateFormData.newMissionName
      ) {
        toast.error("Please fill in all fields.");
        return;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/replicate/mission/${currentMissionId}`,
        {
          newSkillId: replicateFormData.newSkillId,
          oldStageId: stageId,
          newStageId: replicateFormData.newStageId,
          newMissionName: replicateFormData.newMissionName,
          oldMissionId: currentMissionId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        toast.success(`${response.data.message}`);
        fetchData();
        setReplicateDialogOpen(false);
      } else if (response.status === 400) {
        toast.error(`${response.data.message}`);
      }
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`${error.response.data.message}`);
      } else {
        toast.error("An error occurred during replication.");
      }
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const apiUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/missions/delete/${missionToDelete}`;
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.delete(apiUrl, config);

      if (response.status === 200) {
        console.log(`Mission ${missionToDelete} deleted successfully`);
        const updatedMissions = missions.filter(
          (mission) => mission.mission_id !== missionToDelete
        );
        setMissions(updatedMissions);
        toast.success("Missions Deleted Successfully");
      } else {
        console.error(
          `Error deleting Mission ${missionToDelete}`,
          response.data
        );
        toast.error("Error deleting Mission ");
      }
    } catch (error) {
      console.error(`Error deleting Mission ${missionToDelete}`, error);
      toast.error("Error deleting Mission ");
    }
    setDeleteOpen(false);
    setMissionToDelete(null);
  };

  const handleDelete = async (missionId) => {
    setDeleteOpen(true);
    setMissionToDelete(missionId);
  };

  const handleDownload = async (token, missionId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/exercise/download/${missionId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        }
      );
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "questions.xlsx";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("Questions downloaded successfully");
    } catch (error) {
      console.error("Error downloading questions:", error);
      toast.error(`Error downloading questions: ${error.message}`);
    }
  };

  const onDownloadQuestions = (missionId) => {
    if (missionId && token) {
      handleDownload(token, missionId);
    } else {
      toast.error("No mission ID or token available");
    }
  };

  const handleCloseDialog = () => {
    setInsertedQuestionIds([]);
    setSelectedAudioFiles([]);
    setSelectedAudioLanguages([]);
    setSelectedAudioUploadScope("all");
    setReplaceAudioLanguages({});
    setAudioScopes({});
    setAudioAction(null);
    setPendingAudioConfirmation(null);
    setAddDialogOpen(false);
    setReplicateDialogOpen(false);
    setCurrentMissionId(null);
  };

  const appendMissionFormFields = (missionFormData, currentSkillId, currentStageId) => {
    missionFormData.append("missionName", formData.name || "");
    missionFormData.append("videoLink", formData.videoLink || "");
    missionFormData.append("missionOrder", formData.missionOrder || "");
    missionFormData.append("questionType", formData.questionType || (formData.missionId ? "lorem" : "Lorem"));
    missionFormData.append("instructions", formData.instructions || "");
    missionFormData.append("displayColumns", formData.displayColumns || "");
    missionFormData.append("speed", formData.speed || "");
    missionFormData.append("accuracy", formData.accuracy || "");
    missionFormData.append("maxQuestions", formData.maxQuestions || "");
    missionFormData.append(
      "visibility",
      formData.visibility === "1" || formData.visibility === 1 || formData.visibility === true
        ? "1"
        : "0"
    );
    missionFormData.append(
      "shouldUpload",
      formData.shouldUpload === "1" || formData.shouldUpload === 1 || formData.shouldUpload === true
        ? "1"
        : "0"
    );
    missionFormData.append("coinType", formData.coinType || "");
    missionFormData.append("questionIds", JSON.stringify(insertedQuestionIds));
    missionFormData.append("startInstructions", formData.startInstructions || "");
    missionFormData.append("specializationId", 0);
    missionFormData.append("skillId", currentSkillId);
    missionFormData.append("stageId", currentStageId);
    missionFormData.append(
      "isStartRequired",
      formData.isStartRequired === "1" ||
        formData.isStartRequired === 1 ||
        formData.isStartRequired === true
        ? "1"
        : "0"
    );

    if (formData.missionId && Array.isArray(formData.audioFiles)) {
      missionFormData.append(
        "audioFiles",
        JSON.stringify(
          formData.audioFiles.map((audio) => ({
            audioUrl: audio?.audioUrl || audio?.audio_url || "",
            audioKey: audio?.audioKey || audio?.audio_key || "",
            language:
              audio?.language ||
              audio?.audioLanguage ||
              audio?.audio_language ||
              null,
          }))
        )
      );
    }
  };

  const normalizeAudioFile = (audio) => ({
    audioUrl: audio?.audioUrl || audio?.audio_url || "",
    audioKey: audio?.audioKey || audio?.audio_key || "",
    language:
      audio?.language ||
      audio?.audioLanguage ||
      audio?.audio_language ||
      audio?.audioLang ||
      audio?.audio_lang ||
      null,
  });

  const getMissionAudioFiles = (mission) => {
    const rawAudioFiles = Array.isArray(mission?.audioFiles)
      ? mission.audioFiles
      : Array.isArray(mission?.audio_files)
      ? mission.audio_files
      : [];

    const normalizedAudioFiles = rawAudioFiles
      .map(normalizeAudioFile)
      .filter((audio) => audio.audioUrl || audio.audioKey);

    if (normalizedAudioFiles.length) {
      return normalizedAudioFiles;
    }

    const legacyAudio = normalizeAudioFile({
      audioUrl: mission?.audio_url || mission?.audioUrl,
      audioKey: mission?.audio_key || mission?.audioKey,
      language:
        mission?.language ||
        mission?.audioLanguage ||
        mission?.audio_language ||
        mission?.audioLang ||
        mission?.audio_lang,
    });

    return legacyAudio.audioUrl || legacyAudio.audioKey ? [legacyAudio] : [];
  };

  const getAudioIdentity = (audio, index) =>
    audio?.audioKey || audio?.audioUrl || `audio-${index}`;

  const shortenAudioKey = (audioKey) => {
    if (!audioKey) {
      return "";
    }

    if (audioKey.length <= 36) {
      return audioKey;
    }

    return `${audioKey.slice(0, 18)}...${audioKey.slice(-12)}`;
  };

  const getAudioFileName = (audioUrl) => {
    if (!audioUrl) {
      return "";
    }

    try {
      const pathname = new URL(audioUrl).pathname;
      return decodeURIComponent(pathname.split("/").pop() || "mission-audio");
    } catch (error) {
      return audioUrl.split("/").pop() || "mission-audio";
    }
  };

  const getAudioLabel = (audio) => {
    const fileName = getAudioFileName(audio.audioUrl);
    return fileName || shortenAudioKey(audio.audioKey) || "Mission audio";
  };

  const getAudioLanguageLabel = (language) => language || "Not set";

  const isAudioLanguageSelected = (language) =>
    AUDIO_LANGUAGE_OPTIONS.includes(language);

  const getAudioScope = (audio, index) =>
    audioScopes[getAudioIdentity(audio, index)] || "single";

  const handleAudioScopeChange = (audio, index, scope) => {
    setAudioScopes((previous) => ({
      ...previous,
      [getAudioIdentity(audio, index)]: scope,
    }));
  };

  const getReplaceAudioLanguage = (audio, index) =>
    replaceAudioLanguages[getAudioIdentity(audio, index)] ||
    (isAudioLanguageSelected(audio?.language) ? audio.language : "");

  const handleReplaceAudioLanguageChange = (audio, index, language) => {
    setReplaceAudioLanguages((previous) => ({
      ...previous,
      [getAudioIdentity(audio, index)]: language,
    }));
    handleUpdateAudioLanguage(audio, index, language);
  };

  const handleSelectedAudioLanguageChange = (indexToUpdate, language) => {
    setSelectedAudioLanguages((previous) =>
      previous.map((currentLanguage, index) =>
        index === indexToUpdate ? language : currentLanguage
      )
    );
  };

  const getSelectedAudioLanguageError = () =>
    selectedAudioFiles.findIndex(
      (_, index) => !isAudioLanguageSelected(selectedAudioLanguages[index])
    );

  const appendAudioLanguageFields = (missionAudioData, languages) => {
    if (languages.length === 1) {
      missionAudioData.append("audioLanguage", languages[0]);
      return;
    }

    missionAudioData.append("audioLanguages", JSON.stringify(languages));
  };

  const getAudioPayloadFromResponse = (response) => {
    const responseData = response?.data || {};
    const payload =
      responseData.data?.mission ||
      responseData.mission ||
      responseData.data ||
      responseData;

    if (Array.isArray(payload)) {
      return payload.find(
        (mission) => String(mission?.mission_id) === String(formData.missionId)
      );
    }

    return payload;
  };

  const syncCurrentMissionAudio = async (response) => {
    const payload = getAudioPayloadFromResponse(response);
    const refreshedMissions = await fetchData();
    const refreshedMission = refreshedMissions.find(
      (mission) => String(mission?.mission_id) === String(formData.missionId)
    );
    const source = refreshedMission || payload || {};
    const audioFiles = getMissionAudioFiles(source);
    const primaryAudio = audioFiles[0] || {};

    setFormData((previous) => ({
      ...previous,
      audioFiles,
      audioUrl: primaryAudio.audioUrl || "",
      audioKey: primaryAudio.audioKey || "",
    }));
  };

  const patchMissionAudio = async ({
    body,
    isMultipart = false,
    actionLabel,
  }) => {
    setAudioAction({ label: actionLabel, progress: 0 });

    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/missions/audio/${formData.missionId}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          ...(isMultipart ? {} : { "Content-Type": "application/json" }),
        },
        onUploadProgress: (progressEvent) => {
          if (!progressEvent.total) {
            return;
          }

          setAudioAction((previous) => ({
            ...previous,
            progress: Math.round((progressEvent.loaded * 100) / progressEvent.total),
          }));
        },
      }
    );

    await syncCurrentMissionAudio(response);
    return response;
  };

  const handleAudioFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    event.target.value = "";

    if (!files.length) {
      return;
    }

    setSelectedAudioFiles((previous) => [...previous, ...files]);
    setSelectedAudioLanguages((previous) => [
      ...previous,
      ...files.map(() => ""),
    ]);
  };

  const handleUploadSelectedAudioFiles = () => {
    if (!formData.missionId || !selectedAudioFiles.length) {
      return;
    }

    const missingLanguageIndex = getSelectedAudioLanguageError();

    if (missingLanguageIndex !== -1) {
      toast.error(
        `Please select a language for ${selectedAudioFiles[missingLanguageIndex].name}.`
      );
      return;
    }

    const missionAudioData = new FormData();
    missionAudioData.append("appendAudio", "true");
    missionAudioData.append("audioScope", selectedAudioUploadScope);
    selectedAudioFiles.forEach((file) => missionAudioData.append("audio", file));
    appendAudioLanguageFields(missionAudioData, selectedAudioLanguages);

    patchMissionAudio({
      body: missionAudioData,
      isMultipart: true,
      actionLabel: "Uploading audio",
    })
      .then((response) => {
        toast.success(response.data.message || "Mission audio uploaded successfully");
        setSelectedAudioFiles([]);
        setSelectedAudioLanguages([]);
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Error uploading mission audio");
      })
      .finally(() => {
        setAudioAction(null);
      });
  };

  const handleRemoveQueuedAudio = (indexToRemove) => {
    setSelectedAudioFiles((previous) =>
      previous.filter((_, index) => index !== indexToRemove)
    );
    setSelectedAudioLanguages((previous) =>
      previous.filter((_, index) => index !== indexToRemove)
    );
  };

  const executeDeleteAudio = async ({ audio, scope }) => {
    if (!audio.audioKey) {
      toast.error("Cannot delete this audio because its audio key is missing.");
      return;
    }

    try {
      const response = await patchMissionAudio({
        body: {
          deleteAudioKey: audio.audioKey,
          audioScope: scope,
        },
        actionLabel: "Deleting audio",
      });
      toast.success(response.data.message || "Mission audio deleted successfully");
    } catch (error) {
      toast.error(error.response?.data?.message || "Error deleting mission audio");
    } finally {
      setAudioAction(null);
      setPendingAudioConfirmation(null);
    }
  };

  const handleDeleteAudio = (audio, index) => {
    const scope = getAudioScope(audio, index);

    if (scope === "all") {
      setPendingAudioConfirmation({ type: "delete", audio, index, scope });
      return;
    }

    executeDeleteAudio({ audio, index, scope });
  };

  const executeUpdateAudioLanguage = async ({ audio, scope, language }) => {
    if (!audio.audioKey) {
      toast.error("Cannot update language because this audio key is missing.");
      return;
    }

    if (!isAudioLanguageSelected(language)) {
      toast.error("Please select a language for this audio.");
      return;
    }

    try {
      const response = await patchMissionAudio({
        body: {
          audioKey: audio.audioKey,
          audioLanguage: language,
          audioScope: scope,
        },
        actionLabel: "Updating audio language",
      });
      toast.success(response.data.message || "Audio language updated successfully");
    } catch (error) {
      toast.error(error.response?.data?.message || "Error updating audio language");
    } finally {
      setAudioAction(null);
      setPendingAudioConfirmation(null);
    }
  };

  const handleUpdateAudioLanguage = (audio, index, languageOverride) => {
    const scope = getAudioScope(audio, index);
    const language = languageOverride || getReplaceAudioLanguage(audio, index);

    if (!isAudioLanguageSelected(language)) {
      toast.error("Please select a language for this audio.");
      return;
    }

    if (scope === "all") {
      setPendingAudioConfirmation({
        type: "language",
        audio,
        scope,
        language,
      });
      return;
    }

    executeUpdateAudioLanguage({ audio, scope, language });
  };

  const executeReplaceAudio = async ({ audio, index, scope, file, language }) => {
    if (scope === "all" && !audio.audioKey) {
      toast.error("Cannot replace across missions because this audio key is missing.");
      return;
    }

    if (!isAudioLanguageSelected(language)) {
      toast.error("Please select a language for the replacement audio.");
      return;
    }

    const missionAudioData = new FormData();
    missionAudioData.append("audio", file);
    missionAudioData.append("audioScope", scope);
    missionAudioData.append("audioLanguage", language);

    if (audio.audioKey) {
      missionAudioData.append("replaceAudioKey", audio.audioKey);
    } else if (scope === "single") {
      missionAudioData.append("replaceAudioIndex", index);
    }

    try {
      const response = await patchMissionAudio({
        body: missionAudioData,
        isMultipart: true,
        actionLabel: "Replacing audio",
      });
      toast.success(response.data.message || "Mission audio replaced successfully");
    } catch (error) {
      toast.error(error.response?.data?.message || "Error replacing mission audio");
    } finally {
      setAudioAction(null);
      setPendingAudioConfirmation(null);
    }
  };

  const handleReplaceAudioFileChange = (event, audio, index) => {
    const file = event.target.files?.[0] || null;
    event.target.value = "";

    if (!file) {
      return;
    }

    const scope = getAudioScope(audio, index);
    const language = getReplaceAudioLanguage(audio, index);

    if (!isAudioLanguageSelected(language)) {
      toast.error("Please select a language for the replacement audio.");
      return;
    }

    if (scope === "all") {
      setPendingAudioConfirmation({
        type: "replace",
        audio,
        index,
        scope,
        file,
        language,
      });
      return;
    }

    executeReplaceAudio({ audio, index, scope, file, language });
  };

  const handleConfirmAudioAction = () => {
    if (!pendingAudioConfirmation) {
      return;
    }

    if (pendingAudioConfirmation.type === "delete") {
      executeDeleteAudio(pendingAudioConfirmation);
      return;
    }

    if (pendingAudioConfirmation.type === "language") {
      executeUpdateAudioLanguage(pendingAudioConfirmation);
      return;
    }

    executeReplaceAudio(pendingAudioConfirmation);
  };

  const handleSave = async (skillId, stageId) => {
    try {
      if (!isTimeValid(formData.speed)) {
        toast.error('Invalid time format for Speed. Please use "hh:mm:ss".');
        return;
      }
      if (formData.missionId) {
        if (selectedAudioFiles.length) {
          toast.error("Upload selected audios before saving the mission.");
          return;
        }

        const missionFormData = new FormData();
        appendMissionFormFields(missionFormData, skillId, stageId);

        const response = await axios.put(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/missions/update/${formData.missionId}`,
          missionFormData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 200) {
          toast.success(`${response.data.message}`);
          const updatedMissions = missions.map((mission) =>
            mission.mission_id === formData.missionId
              ? { ...mission, ...formData }
              : mission
          );
          setMissions(updatedMissions);
          fetchData();
        } else {
          toast.error(`${response.data.message}`);
        }
      } else {
        const missionFormData = new FormData();
        appendMissionFormFields(missionFormData, skillId, stageId);

        const missingLanguageIndex = getSelectedAudioLanguageError();

        if (missingLanguageIndex !== -1) {
          toast.error(
            `Please select a language for ${selectedAudioFiles[missingLanguageIndex].name}.`
          );
          return;
        }

        selectedAudioFiles.forEach((file) => {
          missionFormData.append("audio", file);
        });

        if (selectedAudioFiles.length) {
          appendAudioLanguageFields(missionFormData, selectedAudioLanguages);
        }

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_KEY}/missions/add`,
          missionFormData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
            onUploadProgress: (progressEvent) => {
              if (!selectedAudioFiles.length || !progressEvent.total) {
                return;
              }

              setAudioAction({
                label: "Uploading audio",
                progress: Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                ),
              });
            },
          }
        );

        if (response.status === 200) {
          toast.success(`${response.data.message}`);
          fetchData();
        } else {
          toast.error(`${response.data.message}`);
        }
      }

      handleCloseDialog();
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast.error(`${error.response.data.message}`);
      } else {
        toast.error("An error occurred while saving the mission.");
      }
      setAudioAction(null);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const isTimeValid = (time) => {
    const timeRegex = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/;
    return timeRegex.test(time);
  };

  const handleQuestionsAdded = (ids) => {
    setInsertedQuestionIds(ids);
  };

  function formatTime(timeStr) {
    const [hours, minutes, seconds] = timeStr.split(":").map(Number);

    if (hours === 0) {
      if (minutes === 0) {
        return `${seconds} sec`;
      } else if (seconds === 0) {
        return `${minutes} mins`;
      } else {
        return `${minutes} mins ${seconds} sec`;
      }
    } else if (hours === 1) {
      if (minutes === 0) {
        if (seconds === 0) {
          return `${hours} hr`;
        } else {
          return `${hours} hr ${seconds} sec`;
        }
      } else if (seconds === 0) {
        return `${hours} hr ${minutes} mins`;
      } else {
        return `${hours} hr ${minutes} mins ${seconds} sec`;
      }
    } else {
      if (minutes === 0) {
        if (seconds === 0) {
          return `${hours} hrs`;
        } else {
          return `${hours} hrs ${seconds} sec`;
        }
      } else if (seconds === 0) {
        return `${hours} hrs ${minutes} mins`;
      } else {
        return `${hours} hrs ${minutes} mins ${seconds} sec`;
      }
    }
  }

  const onStartInstructionChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      startInstructions: value,
    }));
  };

  const renderMissionAudioSection = () => {
    const existingAudioFiles = formData.audioFiles || [];
    const audioActionLoading = Boolean(audioAction);
    const audioControlSx = {
      width: "100% !important",
      marginBottom: "0 !important",
      "& .MuiOutlinedInput-root": {
        height: "44px",
        "& fieldset": {
          borderColor: "#d8dce8",
        },
        "&:hover fieldset": {
          borderColor: "#313C63",
        },
        "&.Mui-focused fieldset": {
          borderColor: "#313C63",
        },
      },
    };
    const compactButtonSx = {
      width: "100% !important",
      minWidth: "120px",
      height: "44px !important",
    };

    return (
      <div
        style={{
          border: "1px solid #e0e0e0",
          borderRadius: "6px",
          padding: "14px 18px",
          marginBottom: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
            flexWrap: "wrap",
            marginBottom: "12px",
          }}
        >
          <div>
            <div style={{ fontSize: "14px", fontWeight: 500 }}>
              Mission Audios
            </div>
            <div style={{ fontSize: "12px", color: "#666" }}>
              {formData.missionId
                ? `${existingAudioFiles.length} audio file${
                    existingAudioFiles.length === 1 ? "" : "s"
                  } attached`
                : `${selectedAudioFiles.length} audio file${
                    selectedAudioFiles.length === 1 ? "" : "s"
                  } selected`}
            </div>
          </div>
          <Button
            variant="outlined"
            component="label"
            className="outlined-button"
            disabled={audioActionLoading}
          >
            Upload Audio
            <input
              hidden
              type="file"
              multiple
              accept=".mp3,.wav,.m4a,.ogg,.webm,.flac,.aac,audio/*"
              onChange={handleAudioFileChange}
            />
          </Button>
        </div>

        {audioActionLoading && (
          <div style={{ fontSize: "12px", color: "#666", marginBottom: "10px" }}>
            {audioAction.label}
            {typeof audioAction.progress === "number"
              ? ` ${audioAction.progress}%`
              : ""}
          </div>
        )}

        {selectedAudioFiles.length > 0 && (
          <div style={{ display: "grid", gap: "8px" }}>
            {selectedAudioFiles.map((file, index) => (
              <div
                key={`${file.name}-${index}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "12px",
                  border: "1px solid #eeeeee",
                  borderRadius: "6px",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ flex: "1 1 260px", minWidth: 0 }}>
                  <div style={{ fontSize: "13px", fontWeight: 500, wordBreak: "break-word" }}>
                    {file.name}
                  </div>
                  <div style={{ fontSize: "12px", color: "#666", marginTop: "2px" }}>
                    New audio
                  </div>
                </div>
                <FormControl
                  fullWidth
                  size="small"
                  className="customTextfield"
                  sx={{ ...audioControlSx, flex: "0 1 190px" }}
                >
                  <InputLabel id={`selected-audio-language-${index}`}>
                    Language
                  </InputLabel>
                  <Select
                    labelId={`selected-audio-language-${index}`}
                    value={selectedAudioLanguages[index] || ""}
                    label="Language"
                    onChange={(event) =>
                      handleSelectedAudioLanguageChange(index, event.target.value)
                    }
                    disabled={audioActionLoading}
                  >
                    {AUDIO_LANGUAGE_OPTIONS.map((language) => (
                      <MenuItem key={language} value={language}>
                        {language}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <Button
                  variant="outlined"
                  className="outlined-button"
                  onClick={() => handleRemoveQueuedAudio(index)}
                  disabled={audioActionLoading}
                  sx={{ ...compactButtonSx, flex: "0 1 140px" }}
                >
                  Delete
                </Button>
              </div>
            ))}
            {formData.missionId && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                <FormControl
                  fullWidth
                  size="small"
                  className="customTextfield"
                  sx={{ ...audioControlSx, flex: "0 1 260px" }}
                >
                  <InputLabel id="selected-audio-upload-scope">
                    Audio Scope
                  </InputLabel>
                  <Select
                    labelId="selected-audio-upload-scope"
                    value={selectedAudioUploadScope}
                    label="Audio Scope"
                    onChange={(event) =>
                      setSelectedAudioUploadScope(event.target.value)
                    }
                    disabled={audioActionLoading}
                  >
                    <MenuItem value="all">
                      All active missions with this name
                    </MenuItem>
                    <MenuItem value="single">Current mission only</MenuItem>
                  </Select>
                </FormControl>
                <Button
                  variant="contained"
                  className="filled-button"
                  onClick={handleUploadSelectedAudioFiles}
                  disabled={audioActionLoading}
                  sx={{ width: "180px !important", height: "44px !important" }}
                >
                  Upload Selected
                </Button>
              </div>
            )}
          </div>
        )}

        {formData.missionId && existingAudioFiles.length === 0 && (
          <div style={{ fontSize: "12px", color: "#666" }}>
            No audios attached
          </div>
        )}

        {formData.missionId && existingAudioFiles.length > 0 && (
          <div style={{ display: "grid", gap: "10px" }}>
            {existingAudioFiles.map((audio, index) => {
              const audioIdentity = getAudioIdentity(audio, index);
              const selectedScope = getAudioScope(audio, index);

              return (
                <div
                  key={audioIdentity}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: "16px",
                    padding: "14px",
                    border: "1px solid #eeeeee",
                    borderRadius: "6px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ flex: "1 1 300px", minWidth: 0 }}>
                    {audio.audioUrl && (
                      <audio
                        controls
                        src={audio.audioUrl}
                        style={{ width: "100%", maxWidth: "320px", maxHeight: "40px" }}
                      />
                    )}
                    <div
                      title={audio.audioKey || getAudioLabel(audio)}
                      style={{
                        fontSize: "12px",
                        color: "#666",
                        marginTop: "4px",
                        overflowWrap: "anywhere",
                      }}
                    >
                      {getAudioLabel(audio)}
                    </div>
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "6px",
                        fontSize: "12px",
                        color: "#37446F",
                        background: "#f2f4fb",
                        border: "1px solid #d8dce8",
                        borderRadius: "4px",
                        padding: "4px 8px",
                        marginTop: "8px",
                      }}
                    >
                      DB language: {getAudioLanguageLabel(audio.language)}
                    </div>
                  </div>

                  <div
                    style={{
                      display: "grid",
                    gridTemplateColumns: "repeat(2, minmax(160px, 1fr))",
                    gap: "10px",
                      flex: "0 1 420px",
                      minWidth: "320px",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      className="customTextfield"
                      sx={audioControlSx}
                    >
                      <InputLabel id={`replace-audio-language-${index}`}>
                        Language
                      </InputLabel>
                      <Select
                        labelId={`replace-audio-language-${index}`}
                        value={getReplaceAudioLanguage(audio, index)}
                        label="Language"
                        onChange={(event) =>
                          handleReplaceAudioLanguageChange(
                            audio,
                            index,
                            event.target.value
                          )
                        }
                        disabled={audioActionLoading}
                      >
                        {AUDIO_LANGUAGE_OPTIONS.map((language) => (
                          <MenuItem key={language} value={language}>
                            {language}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>

                    <FormControl
                      fullWidth
                      size="small"
                      className="customTextfield"
                      sx={audioControlSx}
                    >
                      <InputLabel id={`audio-scope-${index}`}>
                        Audio Scope
                      </InputLabel>
                      <Select
                        labelId={`audio-scope-${index}`}
                        value={selectedScope}
                        label="Audio Scope"
                        onChange={(event) =>
                          handleAudioScopeChange(audio, index, event.target.value)
                        }
                        disabled={audioActionLoading}
                      >
                        <MenuItem value="single">Current mission only</MenuItem>
                        <MenuItem value="all">
                          All missions using this audio
                        </MenuItem>
                      </Select>
                    </FormControl>

                    <Button
                      variant="outlined"
                      component="label"
                      className="outlined-button"
                      disabled={audioActionLoading}
                      sx={compactButtonSx}
                    >
                      Replace
                      <input
                        hidden
                        type="file"
                        accept=".mp3,.wav,.m4a,.ogg,.webm,.flac,.aac,audio/*"
                        onChange={(event) =>
                          handleReplaceAudioFileChange(event, audio, index)
                        }
                      />
                    </Button>

                    <Button
                      variant="outlined"
                      className="outlined-button"
                      onClick={() => handleDeleteAudio(audio, index)}
                      disabled={audioActionLoading}
                      sx={compactButtonSx}
                    >
                      Delete
                    </Button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="container-fluid mt-5">
      <div className="align-center-all full-height">
        {isAuthorized ? (
          <Card className="col-md-12 p-3 pt-5 shadow-none">
            <CardContent>
              <div className="top-div">
                <div
                  style={{
                    display: "flex",
                    alignItems: "baseline",
                    gap: "1vw",
                  }}
                >
                  <ArrowBackIosNewRounded
                    onClick={handleBack}
                    style={{ cursor: "pointer" }}
                  />
                  <h2>Missions</h2>
                </div>
                <ToastContainer />
                <Button
                  variant="contained"
                  onClick={handleAdd}
                  className="filled-button"
                >
                  Add
                </Button>
              </div>
              <table className="table">
                <thead className="table-head">
                  <tr>
                    <th>S. No.</th>
                    <th className="text-left">Name</th>
                    <th>No. of Questions</th>
                    <th>Time</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {missions.map((mission) => (
                    <tr key={mission?.mission_id}>
                      <td>{mission?.mission_id || ""}</td>
                      <td className="text-left">
                        {mission?.mission_name || ""}
                      </td>
                      <td>{mission?.max_questions}</td>
                      <td>{formatTime(mission?.speed)}</td>
                      <td>
                        <Button
                          variant="contained"
                          onClick={() => handleEdit(mission.mission_id)}
                          className="g-but mr-2"
                        >
                          Edit
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() => handleReplicate(mission.mission_id)}
                          className="y-but mr-2"
                        >
                          Replicate
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() => handleDelete(mission.mission_id)}
                          className="r-but"
                        >
                          Delete
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <Dialog
                open={deleteOpen}
                onClose={(prev) => !prev}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ textAlign: "center" }}
              >
                <ErrorOutlineIcon
                  style={{
                    color: "red",
                    fontSize: "32px",
                    margin: "12px auto",
                  }}
                />
                <DialogTitle
                  id="alert-dialog-title"
                  style={{
                    fontSize: "18px",
                    fontWeight: "500",
                    lineHeight: "0",
                  }}
                >
                  {"Are you Sure?"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id="alert-dialog-description"
                    style={{ fontSize: "12px" }}
                  >
                    You won't be able to revert this!
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      setDeleteOpen(false);
                      setMissionToDelete(null);
                    }}
                    style={{
                      textTransform: "none",
                      width: "120px",
                      height: "36px",
                      border: "2.03px solid #37446F",
                      borderRadius: "5.85px",
                      background: "none",
                      color: "black",
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleConfirmDelete}
                    style={{
                      textTransform: "none",
                      width: "120px",
                      height: "36px",
                      borderRadius: "5.85px",
                      background: "#37446F",
                      color: "white",
                    }}
                    autoFocus
                  >
                    Delete
                  </Button>
                </DialogActions>
              </Dialog>
              <Dialog
                open={Boolean(pendingAudioConfirmation)}
                onClose={() => setPendingAudioConfirmation(null)}
                aria-labelledby="audio-scope-confirm-title"
                aria-describedby="audio-scope-confirm-description"
                style={{ textAlign: "center" }}
              >
                <ErrorOutlineIcon
                  style={{
                    color: "red",
                    fontSize: "32px",
                    margin: "12px auto",
                  }}
                />
                <DialogTitle
                  id="audio-scope-confirm-title"
                  style={{
                    fontSize: "18px",
                    fontWeight: "500",
                    lineHeight: "1.2",
                  }}
                >
                  Confirm audio update
                </DialogTitle>
                <DialogContent>
                  <DialogContentText
                    id="audio-scope-confirm-description"
                    style={{ fontSize: "12px" }}
                  >
                    {pendingAudioConfirmation?.type === "language"
                      ? "This will update the selected audio language for every mission using the same audio."
                      : `This will ${
                          pendingAudioConfirmation?.type === "replace"
                            ? "replace"
                            : "delete"
                        } the selected audio for every mission using the same audio.`}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => setPendingAudioConfirmation(null)}
                    className="outlined-button"
                    variant="outlined"
                    disabled={Boolean(audioAction)}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleConfirmAudioAction}
                    className="filled-button"
                    variant="contained"
                    disabled={Boolean(audioAction)}
                    autoFocus
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
            </CardContent>
          </Card>
        ) : (
          <h2>You are unauthorized to access this page.</h2>
        )}

        {/* Replication Dialog */}
        <Dialog
          open={isReplicateDialogOpen}
          onClose={handleReplicateDialogClose}
          PaperProps={{
            style: {
              width: "35.128vw",
              borderRadius: "0.513vw",
              boxShadow:
                "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
            },
          }}
        >
          <DialogTitle>Replicate Mission</DialogTitle>
          <DialogContent>
            <FormControl
              fullWidth
              margin="normal"
              className="customTextfield"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                  },
                },
              }}
            >
              <InputLabel id="skill-select-label">Skill</InputLabel>
              <Select
                labelId="skill-select-label"
                value={replicateFormData.newSkillId}
                onChange={handleSkillSelectChange}
                label="Skill"
              >
                {skills.map((skill) => (
                  <MenuItem key={skill.skill_id} value={skill.skill_id}>
                    {skill.skill_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl
              fullWidth
              margin="normal"
              className="customTextfield"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                  },
                },
              }}
            >
              <InputLabel id="stage-select-label">Stage</InputLabel>
              <Select
                labelId="stage-select-label"
                value={replicateFormData.newStageId}
                onChange={handleStageSelectChange}
                label="Stage"
              >
                {stages.map((stage) => (
                  <MenuItem key={stage.stage_id} value={stage.stage_id}>
                    {stage.stage_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              label="New Mission Name"
              name="newMissionName"
              value={replicateFormData.newMissionName}
              onChange={(e) =>
                setReplicateFormData({
                  ...replicateFormData,
                  newMissionName: e.target.value,
                })
              }
              fullWidth
              margin="normal"
              type="text"
              className="customTextfield"
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "transparent",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "transparent",
                  },
                },
              }}
            />
            <DialogActions>
              <Button
                onClick={handleReplicateDialogClose}
                className="outlined-button"
                variant="outlined"
              >
                Cancel
              </Button>
              <Button
                onClick={handleReplicateSubmit}
                className="filled-button"
                variant="contained"
              >
                Replicate
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>

        {/* Add/Edit Mission Dialog */}
        <Dialog
          open={isAddDialogOpen}
          onClose={handleCloseDialog}
          PaperProps={{
            style: {
              width: "68.718vw",
              maxWidth: "100vw",
              padding: "1.5rem",
              borderRadius: "0.513vw",
              boxShadow:
                "4px 4px 8px 0px #AEAEC099, box-shadow: -4px -4px 8px 0px #FFFFFF80",
            },
          }}
        >
          <DialogTitle style={{ padding: 0 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>{formData.missionId ? "Update Mission" : "Add Mission"}</div>
              <Button
                variant="contained"
                onClick={() => onDownloadQuestions(formData.missionId)}
                className="filled-button"
              >
                Download Questions
              </Button>
            </div>
          </DialogTitle>
          <DialogContent style={{ padding: 0 }}>
            <Grid container spacing={0}>
              {inputFields.map((field) => (
                <Grid item xs={6} key={field.name}>
                  <TextField
                    label={field.label}
                    name={field.name}
                    value={formData[field.name] || ""}
                    onChange={handleInputChange}
                    fullWidth
                    margin="normal"
                    type={`${
                      field.label.includes("Order") ? "Number" : "text"
                    }`}
                    disabled={field.disabled}
                    error={
                      field.name === "speed" && !isTimeValid(formData.speed)
                    }
                    placeholder={
                      field.name === "speed" ? "hh:mm:ss" : field.label
                    }
                    className="customTextfield"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: "transparent",
                        },
                        "&:hover fieldset": {
                          borderColor: "transparent",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "transparent",
                        },
                      },
                    }}
                  />
                </Grid>
              ))}
              <Grid
                container
                item
                xs={12}
                mb={"2vw"}
                mt={"2vw"}
                key={"startInstructions"}
              >
                <Grid item xs={6} height={"max-content"}>
                  <TextEditor
                    propsContent={formData["startInstructions"]}
                    propPlaceholder={"Start Instuctions"}
                    onChangeContent={onStartInstructionChange}
                  />
                </Grid>
                <Grid container item xs={6}>
                  <Grid container item xs={12} justifyContent={"space-evenly"} flexWrap={"nowrap"}>
                    <Grid item   flexGrow={3} flexBasis={"20%"} >
                    <FormControlLabel
                      control={
                        <CustomSwitch
                          checked={visibility}
                          onChange={handleVisibilityChange}
                          name="visibility"
                          color="primary"
                        />
                      }
                      style={{
                        marginLeft:"0px",
                        marginRight:"1vw",
                        fontSize:"14px"
                      }}
                      sx={{
                        "& .MuiTypography-root":{
                          paddingLeft:"2px"
                        }
                      }}
                      labelPlacement="start"
                      label="Visibility"
                    />

                    </Grid>
                    <Grid item  flexGrow={3} >
                    <FormControlLabel
                      control={
                        <CustomSwitch
                          checked={formData.shouldUpload}
                          onChange={handleUploadChange}
                          name="Solution Required"
                          color="primary"
                        />
                      }
                      style={{
                        marginLeft:"0px",
                        marginRight:"1vw",
                        fontSize:"14px"
                      }}
                      sx={{
                        "& .MuiTypography-root":{
                          paddingLeft:"2vw"
                        }
                      }}
                      labelPlacement="start"
                      label="Solution Required"
                    />
                    </Grid>
                    <Grid item flexGrow={3}  >
                    <FormControlLabel
                      control={
                        <CustomSwitch
                          checked={formData.isStartRequired}
                          onChange={handleStartInstructionChange}
                          name="Special Instruction Required"
                          color="primary"
                        />
                      }

                      labelPlacement="start"
                      style={{
                        marginLeft:"0px",
                        marginRight:"1vw",
                        fontSize:"14px"
                      }}
                      sx={{
                        "& .MuiTypography-root":{
                          // paddingLeft:"2vw",
                          wordWrap:"break-word",
                        }
                      }}
                      label="Special Instruction Required"
                    />
                    </Grid>
                  </Grid>
                  <Question
                    onQuestionsAdded={handleQuestionsAdded}
                    questionType={formData.questionType}
                    missionId={formData.missionId}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} mt={2}>
                {renderMissionAudioSection()}
              </Grid>
            </Grid>

            <DialogActions
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                onClick={handleCloseDialog}
                variant="outlined"
                className="outlined-button"
              >
                Cancel
              </Button>
              <Button
                onClick={() => handleSave(skillId, stageId)}
                variant="contained"
                className="filled-button"
                disabled={Boolean(audioAction)}
              >
                Save
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
      </div>
      <Battle />
    </div>
  );
};

export default Mission;
